import React,  { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import LoadingGifx from './components/Loading-gif2'
import NavbarContainer from './containers/Navbar-container';
import Footer from './components/Footer';
/* import Empty from './components/Empty'; */
import './style/transition.css';
import './style/shimmer.css';


const Loading = () =>
 <div style={{display:'flex', flexFlow:'column wrap', justifyContent:'center', alignItems:'center', height:'100vh'}}><img style={{width:'200px'}} src={'/images/rom-tra.png'} className="animate " /><p>Loading...</p></div>;

const ItemsListContainer =  lazy(() => import('./containers/Items-list-container'));
const ItemContainer =  lazy(() => import('./containers/Item-container'));
const CheckoutContainer =  lazy(() => import('./containers/Checkout-container'));
const CartContainer =  lazy(() => import('./containers/Cart-container'));
const HomepageContainer =  lazy(() => import('./containers/Homepage-container'));
const SubcatsList =  lazy(() => import('./components/Subcats-list'));
const AdminContainer =  lazy(() => import('./containers/Admin-container'));
const Secret =  lazy(() => import('./components/Secret'));
const review =  lazy(() => import('./components/review'));
const order =  lazy(() => import('./components/order'));
const Empty =  lazy(() => import('./components/Empty'));
const Launch =  lazy(() => import('./components/Launch'));
const Wishlist =  lazy(() => import('./components/MyWishlist'));
const Search =  lazy(() => import('./components/Search'));
const Women = lazy(()=>import( './components/women'));
const Men = lazy(()=>import( './components/men'));
const Contact = lazy(()=>import( './components/contact'));
const StoreLocator = lazy(()=>import( './components/storeLocator'));
const TrackOrder = lazy(()=>import( './components/TrackOrder'));
const Print = lazy(()=>import( './components/PrintOrder'));
const About = lazy(()=>import( './components/about-us'));
const Router = () => (
  <div>
    <NavbarContainer />
      
      
      <Suspense fallback={<LoadingGifx/>}>
      <Switch>
        <Route exact path='/' component={HomepageContainer} />
        <Route exact path='/productslist' component={ItemsListContainer} />       
        <Route exact path='/item/:id/:item' component={ItemContainer} />
        <Route exact path='/checkout' component={CheckoutContainer} />
        <Route exact path='/cart' component={CartContainer} />        
        <Route exact path='/productslist/:gender' component={ItemsListContainer} />
        <Route exact path='/products/:men' component={ItemsListContainer} />
        <Route exact path='/brand/:brand' component={ItemsListContainer} />
        <Route exact path='/category/:gender' component={SubcatsList} />
        <Route exact path='/admin' component={AdminContainer} />
        <Route exact path='/dashboard' component={Secret} />
        <Route exact path='/print/:id' component={Print} />
        <Route exact path='/dashboard/:id' component={Secret} />
        <Route exact path='/review/' component={review} />
        <Route exact path='/review/:id' component={review} />
        <Route exact path='/order/:pid' component={order} />
        <Route exact path='/wishlist' component={Wishlist} />
        <Route exact path='/search' component={Search} />
        <Route exact path='/women' component={Women} />
        <Route exact path='/men' component={Men} />
        <Route exact path='/contact' component={Contact} />
        <Route exact path='/locator' component={StoreLocator} />
        <Route exact path='/track-order' component={TrackOrder} />
        <Route exact path='/about' component={About} />
        <Route exact path='/about/:sub' component={About} />
        <Route  component={Empty}/>
      </Switch>
      </Suspense>     
    <Footer />
  </div>
);

export default Router;



// WEBPACK FOOTER //
// ./src/Router.js